import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Kontaktbereich from "./sections/Kontaktbereich";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Kontaktbereich />
      <Footer />
    </div>;
}